import HttpUtil from 'utils/http-util';
import { ROUTE_API } from 'utils/route-util';

const NOTIFICATION_API = {
  today: async () => {
    const res: INotification.Root[] = await HttpUtil.get(ROUTE_API.notiToday);
    return res;
  },
  upcoming: async () => {
    const res: INotification.Root[] = await HttpUtil.get(
      ROUTE_API.notiUpcoming
    );
    return res;
  },
  anniversary: async ({ status }: { status: string }) => {
    const res: INotification.Root[] = await HttpUtil.get(
      ROUTE_API.notiAnniversary,
      {
        params: {
          status: status,
        },
      }
    );
    return res;
  },
  sendGift: async ({ id }: { id?: number }) => {
    const res: INotification.Root[] = await HttpUtil.post(
      ROUTE_API.notiSendGift.replace(':id', `${id}`)
    );
    return res;
  },
  totalEventToday: async () => {
    const res: INotification.TotalEventToday = await HttpUtil.get(
      ROUTE_API.notiTotal
    );
    return res;
  },
};
export default NOTIFICATION_API;
